<template>
  <path
    d="M17 7.00018H7C4.24 7.00018 2 9.24018 2 12.0002C2 14.7602 4.24 17.0002 7 17.0002H17C19.76 17.0002 22 14.7602 22 12.0002C22 9.24018 19.76 7.00018 17 7.00018ZM7 15.0002C5.34 15.0002 4 13.6602 4 12.0002C4 10.3402 5.34 9.00018 7 9.00018C8.66 9.00018 10 10.3402 10 12.0002C10 13.6602 8.66 15.0002 7 15.0002Z"
  />
</template>
